import React from 'react';

import { progressBarAlert } from './styles';

interface AlertProgressBarProps {
  color: string;
  duration: number;
}

export const AlertProgressBar: React.FC<AlertProgressBarProps> = React.memo(
  ({ color, duration }: any) => {
    return (
      <div className={progressBarAlert(color, duration)} id='progress-bar' />
    );
  }
);
